import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut, Briefcase, Clock, Receipt, FileText, Settings, Calendar, Lock, ShieldCheck } from "lucide-react";

export default function MorePage() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const items = [
    { to: "/hs", label: "H&S", Icon: ShieldCheck, testid: "more-hs", roles: ["Admin","Manager"] },
    { to: "/programme", label: "Works Programme", Icon: Calendar, testid: "more-programme", roles: ["Admin","Manager"] },
    { to: "/reports", label: "Reports", Icon: FileText, testid: "more-reports", roles: ["Admin","Manager"] },
    { to: "/operations", label: "Operations", Icon: Briefcase, testid: "more-operations", roles: ["Admin","Manager"] },
    { to: "/configuration", label: "Configuration", Icon: Settings, testid: "more-config", roles: ["Admin"] },
    { to: "/change-password", label: "Change password", Icon: Lock, testid: "more-change-password" },
  ].filter(i => !i.roles || i.roles.includes(user?.role));

  return (
    <div className="space-y-3" data-testid="more-page">
      <h1 className="text-2xl">More</h1>
      <div className="card">
        <div className="text-xs opacity-70">Signed in as</div>
        <div className="text-silver">{user?.name} <span className="opacity-60 text-sm">({user?.role})</span></div>
      </div>
      <ul className="divide-y divide-neutral-800 card !p-0">
        {items.map(it => (
          <li key={it.to}>
            <Link to={it.to} data-testid={it.testid}
              className="flex items-center gap-3 px-4 py-3 hover:bg-neutral-900">
              <it.Icon size={18} className="text-silver"/>
              <span>{it.label}</span>
            </Link>
          </li>
        ))}
      </ul>
      <button data-testid="btn-logout-more" onClick={logout} className="btn-ghost w-full text-sm flex items-center justify-center gap-2 py-3">
        <LogOut size={16}/> Logout
      </button>
    </div>
  );
}
